export class M3DinProcesos{
    public id_proceso:string;
    public id_sub_proceso:string;
    public id_dinamica:string;
    public tipo_dinam:string;
    public titulo:string;
    public estructura_destino: string;
    public VDefault: string;
    public Requerido:boolean;
}